import React from 'react';

import PropTypes from 'prop-types';

const Form = ({ children, ...formProps }) => {
    return (
        <form
            data-forms="floating-label"
            className="ml-form"
            {...formProps}
        >
            { children }
        </form>
    );
};

Form.propTypes = {
    children: PropTypes.node,
};

export default Form;
